import { useEffect, useState } from "react";
import type { LocalRunRecord } from "../../domain/localRun";
import { resolveStoredProjectHistory } from "../../domain/projectHistory";
import { browserState } from "../utils";

/** The active workspace captures history on all steps, including action edits outside History. */
export function ProjectHistorySync({ record }: { record: LocalRunRecord | null }) {
  const [error, setError] = useState("");
  useEffect(() => {
    if (!record) { setError(""); return; }
    const store = browserState(); let syncing = false;
    const sync = () => {
      if (syncing || store.status().state === "recovery_required") return;
      syncing = true;
      try {
        const old = store.readJson("shadow-project-history", null), actions = store.readJson("shadow-project-actions", null);
        const next = resolveStoredProjectHistory(record, store.readJson("shadow-assessment-run", null), old, actions, store.readJson("shadow-action-status", {}));
        if (!next) { setError(""); return; }
        if (JSON.stringify(old) !== JSON.stringify(next)) store.writeJson("shadow-project-history", next);
        if (JSON.stringify(actions) !== JSON.stringify(next.actions)) store.writeJson("shadow-project-actions", next.actions);
        setError("");
      } catch {
        setError("Project history could not be extended. Previous originals are preserved. Open History for recovery or export; the current assessment remains separate.");
      } finally { syncing = false; }
    };
    sync(); const unsubscribe = store.subscribe(sync); return unsubscribe;
  }, [record]);
  return error ? <p className="statusError projectHistorySyncError" role="alert">{error}</p> : null;
}
